'use es6';

import { Tag } from 'foundations-components/transitional/components/Tag';
import PropTypes from 'prop-types';
import * as FilterKey from '../../../constants/search/FilterKey';
import FilterTagText from './FilterTagText';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterTag = ({
  filterKey,
  onCloseClick,
  value
}) => {
  return /*#__PURE__*/_jsx(Tag, {
    closeable: true,
    inline: true,
    onCloseClick: onCloseClick,
    marginInlineStart: "0",
    marginInlineEnd: "200",
    marginBlock: "100",
    children: /*#__PURE__*/_jsx(FilterTagText, {
      filterKey: filterKey,
      value: value
    })
  });
};
FilterTag.propTypes = {
  filterKey: PropTypes.oneOf(Object.values(FilterKey)).isRequired,
  onCloseClick: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]).isRequired
};
export default FilterTag;